import { AbstractModel } from '@uzurv/core';
import { inheritSerialization, autoserialize } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RideLimitPeriod extends AbstractModel {
  @autoserialize
  name: string;
}
